import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * システム管理上のグループのフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const SystemUpdateGroupFormBase: FC<Props> = ({ register }) => (
  <Input
    id="systemUpdateGroup"
    type="text"
    {...register('systemUpdateGroup', {
      required: '必須項目です。',
      maxLength: {
        value: 100,
        message:
          'システム管理上のグループは 100 文字以内にする必要があります。',
      },
    })}
  />
);
